import React from 'react';
import ExpenseRow from './ExpenseRow';
import Pagination from '../Pagination';
import s from './ExpenseTable.module.css';

const COLUMNS = ['Expense', 'Revenue', 'Category', 'Payee', 'Attachment', 'Description'];

// The list. Presentational: it renders the rows it is handed and reports
// clicks upward. The slicing, sorting and filtering all happen in
// useExpenseList — this only knows which page it was given.
export default function ExpenseTable({
  rows,
  // `(entryId) => attachments` (#183). A function rather than a map, because
  // that is the shape `useExpenses().attachmentsFor` already has and turning it
  // into one here would be a second place that knows a recurring instance's
  // receipts are its rule's. Defaulted to none, like `ExpenseRow`'s own prop and
  // for the same reason.
  attachmentsFor = () => [],
  sort,
  onSortByDate,
  rowMenuId,
  onRowMenuToggle,
  onRowMenuClose,
  onEdit,
  onDelete,
  onOpenAttachment,
  page,
  pageCount,
  perPage,
  total,
  onPageChange,
  onPerPageChange,
}) {
  const dateArrow = sort.key === 'occurredOn' ? (sort.desc ? '↓' : '↑') : '';

  return (
    <div className={s.wrap}>
      <table className={s.table}>
        <thead>
          <tr>
            <th className={s.sortable} onClick={onSortByDate}>Date {dateArrow}</th>
            {COLUMNS.map((c) => <th key={c}>{c}</th>)}
            <th />
          </tr>
        </thead>
        <tbody>
          {rows.map((e) => {
            // A recurring rule yields one row per month from a single document,
            // so the document id alone is not unique in the list — the date is
            // what separates September's rent from October's.
            const key = `${e.id}:${e.occurredOn}`;
            return (
              <ExpenseRow
                key={key}
                entry={e}
                // The receipts on this entry (#183). Resolved by the page from
                // one window rather than read off the row, and keyed on the
                // *document* id — `e.id` is the rule's id for a recurring
                // entry, whose monthly instances all share it and therefore
                // share its receipts, which is what the list already does with
                // every other field on them.
                attachments={attachmentsFor(e.instanceOf || e.id)}
                menuOpen={rowMenuId === key}
                onMenuToggle={() => onRowMenuToggle(key)}
                onMenuClose={onRowMenuClose}
                onEdit={onEdit}
                onDelete={onDelete}
                onOpenAttachment={onOpenAttachment}
              />
            );
          })}
        </tbody>
      </table>
      <Pagination
        page={page}
        pageCount={pageCount}
        perPage={perPage}
        total={total}
        onPageChange={onPageChange}
        onPerPageChange={onPerPageChange}
      />
    </div>
  );
}
